import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69f0a17663911b00140b46ff/komhunter/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69f0a17663911b00140b46ff/komhunter/src/app/welcome-screen/components/WelcomeHero.tsx");
